// app.js
import React, {useState} from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { toast, Toaster } from 'react-hot-toast';
import FlowDesigner from './components/FlowDesigner';
// import { ReactFlowProvider } from 'reactflow';
import { ReactFlowProvider } from '@xyflow/react';
import { SettingsProvider } from './context/SettingsContext/SettingsContext';
import { FlowProvider } from './context/FlowContext/FlowContext';
import { ApiProvider } from './context/ApiContext/ApiContext';

const App = () => {
  const [ canvasColor, setCanvasColor ] = useState('#0a1120');

  return (
    <SettingsProvider>
      <FlowProvider>
        <ApiProvider>
          <DndProvider backend={HTML5Backend}>
            <ReactFlowProvider>
              <div className={`app`}
                style={{backgroundColor: canvasColor}}
              >
                {/* <Toaster position="top-right" /> */}
                <Toaster
                    position="top-right"
                    containerStyle={{
                      right: 20,
                      top: 2,
                    }}
                    toastOptions={{
                      style: {
                        background: '#333',
                        color: '#fff',
                        fontSize: '14px'
                      },
                      success: {
                        duration: 4000,
                        style: {
                          background: 'black',
                        },
                      },
                      error: {
                        duration: 4000,
                        style: {
                          background: 'red',
                        },
                      },
                    }}
                  />
                <FlowDesigner canvasColor={canvasColor} setCanvasColor={setCanvasColor} />
              </div>
            </ReactFlowProvider>
          </DndProvider>
        </ApiProvider>
      </FlowProvider>
    </SettingsProvider>
    );
};

export default App;